import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

type onClosePanelNotification = () => void;
type onSelectOneNotification = () => void;
type onSelectAllNotification = () => void;

@Component({
  selector: 'bulk-action',
  template: require('./bulk-action.component.pug'),
  styles: [require('./bulk-action.component.css').toString()],
})
export class BulkActionComponent implements OnInit, OnDestroy {
  @Input()
  closePanel: onClosePanelNotification;
  @Input()
  selectOnePage: onSelectOneNotification;
  @Input()
  selectAllPages: onSelectAllNotification;

  @Input()
  itemPerPage: number = 0;
  @Input()
  countTotal: BehaviorSubject<number>;
  @Input()
  countSelected: BehaviorSubject<number>;

  @Input()
  commands: string[];

  @Input()
  bulkActions: any;

  sub: any = null;
  sub2: any = null;

  totalSelected = 0;
  isDropup = true;
  
  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.sub = this.countSelected.subscribe(newCount => {
      this.totalSelected = newCount;
      this.checkBulkSlider();
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  bottomHeight = '-250px';

  sliderOpened = false;

  // -------------------------------------------------------------------
  closeBulk() {
    this.bottomHeight = '-250px';
    this.sliderOpened = false;

    // this.closePanel.emit(0);
    if (this.closePanel) {
      this.closePanel();
    }
  }

  // -------------------------------------------------------------------
  openBulk() {
    this.bottomHeight = '0';
    this.sliderOpened = true;
  }

  // -------------------------------------------------------------------
  checkBulkSlider() {
    if (this.sliderOpened == false && this.totalSelected > 0) {
      this.openBulk();
    } else if (this.sliderOpened == true && this.totalSelected <= 0) {
      this.closeBulk();
    }
  }

  // -------------------------------------------------------------------
  selectPage() {
    //this.selectOnePage.emit(0);
    if (this.selectOnePage) {
      this.selectOnePage();
    }
  }

  // -------------------------------------------------------------------
  selectAll() {
    //this.selectAllPages.emit(0);
    if (this.selectAllPages) {
      this.selectAllPages();
    }
  }

  // -------------------------------------------------------------------
  clearSelection() {
    this.totalSelected = 0;
    this.checkBulkSlider();
  }

  // -------------------------------------------------------------------
  triggerAction(action) {
    if (action.trigger) {
      action.trigger();
    }
  }
}
